import { createUseStyles } from 'react-jss';

export default createUseStyles({

  titlePart: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '90px',
    marginBottom: '40px',
    '@media(max-width: 900px)': {
      marginTop: '20px',
      justifyContent: 'center',
    }
  },

  title: {
    color: '#102131',
    fontFamily: '"Manrope", sans-serif',
    fontSize: '22px',
    fontWeight: 'bold',
    marginBottom: '0',
  },

  addBtn: {
    marginLeft: '16px',
  },
  
  badge: {
    margin: '0px 10px',
    backgroundColor: process.env.REACT_APP_PRIMARY_COLOR
  },

  menuIcon: {
    fontSize: '32px',
    marginBottom: '10px',
    cursor: 'pointer',
  },

  tabs: {
    opacity: 0,
    height: 0,
    width: '75%',
    transition: 'width 0.25s',
  },

  tabsOn: {
    opacity: 1,
    width: '100%',
  },

  backdrop: {
    position: 'absolute',
    top: '195px',
    left: 0,
    width: '100%',
    zIndex: 10,
    backgroundColor: '#000',
    opacity: 0,
    transition: 'opacity 0.25s',
  },

  backdropOn: {
    opacity: 0.5,
  }
});
